import React from 'react';
import classes from './index.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { ReactComponent as FacebookIcon } from '../../assets/icons/facebook.svg';
import { ReactComponent as TwitterIcon } from '../../assets/icons/twitter.svg';
import { ReactComponent as LinkedinIcon } from '../../assets/icons/linkedin.svg';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
  return (
    <footer className={classes.Footer}>
      <Container>
        <Row className="mb-5">
          <Col lg={7} md={5}>
            <h2 className={classes.Sub_Title}>Are you ready?</h2>
            <h1 className={classes.Title}>
              Let’s get started
            </h1>
            <HashLink className="btnSizes filledBtn px-5 py-3" smooth to="/#basic-info">Get Started</HashLink>
          </Col>
          <Col lg={3} md={4}>
            <ul className={classes.Search_Types}>
              <li>
                <Link to="/search?entity=federal_opportunities">
                  Contract Opportinities
                </Link>
              </li>
              <li>
                <Link to="/search?entity=b2b_opportunities">
                  B2B Opportunities
                </Link>
              </li>
              <li>
                <Link to="/search?entity=future_opportunities">
                  Future Opportunities
                </Link>
              </li>
              <li>
                <Link to="/search?entity=businesses">
                  Businesses
                </Link>
              </li>
            </ul>
          </Col>
          <Col lg={2} md={3}>
            <ul className={classes.Footer_Links_List}>
              <li>
                <Link to="/about-us">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact-us">
                  Contact Us
                </Link>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="https://www.ncmbc.us/">NCMBC</a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="https://govtide.ait.com">GovTide</a>
              </li>
              <li>
                <a target="_blank" rel="noreferrer" href="https://www.ait.com/">AIT, Inc.</a>
              </li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={classes.Bottom_Footer_Inner}>
              <span>Powered by <a href="https://govtide.ait.com">GovTide</a>®. 2005-2022 All Rights Reserved</span>
              <ul className={classes.Social_List}>
                <li className={classes.Social_List_Item}>
                  <a target="_blank" rel="noreferrer" href="https://www.facebook.com/NCMilitaryBusinessCenter/?filter=2">
                    <FacebookIcon />
                  </a>
                </li>
                <li className={classes.Social_List_Item}>
                  <a target="_blank" rel="noreferrer" href="https://twitter.com/Match_Force">
                    <TwitterIcon />
                  </a>
                </li>
                <li className={classes.Social_List_Item}>
                  <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/signup/cold-join?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fgroups%3Fgid%3D3994345%26goback%3D.anp_3994345_1310153246716_1&trk=login_reg_redirect">
                    <LinkedinIcon />
                  </a>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer;
